import { render, staticRenderFns } from "./ClusterPhonesList.vue?vue&type=template&id=86da8422"
import script from "./ClusterPhonesList.vue?vue&type=script&lang=js"
export * from "./ClusterPhonesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports